import React from "react";

function TodoError({ error }) {
  return <p>Hubo un error, vuelve a recargar...</p>;
}

export { TodoError };
